import { SHIPPING_METHOD } from "../../../../constants";

export const CourierDelivery = ({ tabRef, handleChangeMethod }) => {
  return (
    <div className="nav-item delivery-method-item" role="presentation">
      <div
        ref={tabRef}
        className="nav-link active"
        id="pills-delivery-tab"
        data-bs-toggle="pill"
        data-bs-target="#pills-delivery"
        type="button"
        role="tab"
        aria-controls="pills-delivery"
        aria-selected="true"
        onClick={(e) => {
          handleChangeMethod(e, SHIPPING_METHOD[1]);
        }}
      >
        <div className="delivery-selection">
          <p className="choose-checkout" />
          <h6>Delivery</h6>
        </div>
        <span className="wes-checkout-delivery" />
      </div>
    </div>
  );
};
